<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 39 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.8688 0.00840377C27.8628 -0.334096 36.2967 7.12715 37.1214 16.8347L37.1252 16.9434C37.1519 17.6847 36.6013 18.3147 35.8697 18.4134L35.7219 18.4259C35.4147 18.4359 35.1266 18.3522 34.887 18.2009C33.6698 17.4222 32.1951 16.9984 30.6337 17.0509C27.7952 17.1484 25.3901 18.8234 24.2583 21.1922C22.2775 25.1222 18.2244 27.8909 13.4549 28.0547C6.54281 28.2909 0.743453 22.9659 0.500008 16.1597C0.426082 14.0772 0.881109 12.0959 1.74655 10.3447H1.72871C4.6526 4.4259 10.7209 0.253404 17.8688 0.00840377ZM19.0822 8.15465C15.0481 7.03965 10.7923 7.94465 8.39988 10.1184C6.49438 11.8484 5.49765 13.8859 5.21597 15.4697C4.93556 17.0534 5.68502 19.0509 7.12912 19.5397C8.36801 19.9584 9.69486 19.4047 11.1045 17.8922C12.4938 16.1634 13.5173 14.8284 14.1763 13.8859C14.7945 13.0009 16.2118 11.0884 17.9287 9.35841"
            fill="white"
        />
        <path d="M33.162 29.7043C35.9839 28.7508 37.4836 25.7349 36.5116 22.9681C35.5396 20.2013 32.4641 18.7313 29.6422 19.6847C26.8203 20.6382 25.3206 23.6541 26.2926 26.4209C27.2646 29.1877 30.3401 30.6577 33.162 29.7043Z" fill="white" />
        <path
            opacity="0.25"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.500008 16.1626C0.530598 17.0163 0.64786 17.8476 0.84542 18.6463C3.17663 19.6101 5.42755 19.9538 7.69758 19.7101C7.78425 19.7013 7.86965 19.6889 7.95505 19.6738C7.67591 19.6738 7.4006 19.6326 7.13039 19.5413C5.68502 19.0526 4.93556 17.0551 5.21724 15.4713C5.49765 13.8876 6.49565 11.8501 8.40115 10.1201C10.7795 7.9601 14.9959 7.0551 19.007 8.1376C19.0159 8.12885 19.0261 8.11885 19.035 8.1101C22.1922 4.94635 25.8081 3.54635 29.9939 3.8851C26.6583 1.32134 22.4254 -0.144905 17.8688 0.0113447C10.7209 0.256345 4.6526 4.4276 1.72871 10.3476H1.74655C0.881109 12.0988 0.426082 14.0788 0.500008 16.1626Z"
            fill="url(#paint0_linear_124_357)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_124_357"
                x1="19.2619"
                y1="2.6576"
                x2="1.29863"
                y2="24.8997"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#0A3DFF" stop-opacity="0" />
                <stop offset="1" stop-color="#0A3DFF" />
            </linearGradient>
        </defs>
    </svg>
</template>
